// ATL Comment Form — reCAPTCHA validation + feedback modal
;(function (w, d) {
	var FORM_SELECTOR = '#commentform';
	var ERROR_ID = 'atl-comment-recaptcha-error';
	var MODAL_ID = 'atl-comment-notice-modal';
	var BODY_OPEN_CLASS = 'atl-form-notice-modal-open';
	var ERROR_PARAM = 'atl_comment_error';
	var SUCCESS_PARAM = 'atl_comment_success';
	var config = w.atlCommentConfig || {};

	var ICON_ERROR =
		'<svg viewBox="0 0 24 24" width="28" height="28" focusable="false">' +
			'<path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>' +
		'</svg>';

	var ICON_SUCCESS =
		'<svg viewBox="0 0 24 24" width="28" height="28" focusable="false">' +
			'<path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>' +
		'</svg>';

	function init() {
		var form = d.querySelector(FORM_SELECTOR);
		if (form) {
			form.addEventListener('submit', handleSubmit);
		}
		showRedirectFeedbackIfNeeded();
	}

	function getRecaptchaResponse(form) {
		if (!w.grecaptcha || !w.grecaptcha.getResponse) {
			return '';
		}

		var el = form.querySelector('.g-recaptcha');
		if (!el) {
			return '';
		}

		var widgetId = el.getAttribute('data-widget-id');
		if (widgetId) {
			return w.grecaptcha.getResponse(parseInt(widgetId, 10)) || '';
		}

		return w.grecaptcha.getResponse() || '';
	}

	function getSubmitButton(form) {
		return form.querySelector('#submit') || form.querySelector('.form-submit .site-button');
	}

	function setButtonLoading(btn, loading) {
		if (!btn) {
			return;
		}

		if (loading) {
			if (!btn.dataset.atlOriginalHtml) {
				btn.dataset.atlOriginalHtml = btn.innerHTML;
			}
			btn.disabled = true;
			btn.classList.add('is-loading');
			btn.setAttribute('aria-busy', 'true');
			btn.innerHTML =
				'<i class="fa fa-spinner fa-spin atl-comment-btn-spinner" aria-hidden="true"></i> ' +
				(config.submitting_label || 'Submitting...');
			return;
		}

		btn.disabled = false;
		btn.classList.remove('is-loading');
		btn.removeAttribute('aria-busy');
		if (btn.dataset.atlOriginalHtml) {
			btn.innerHTML = btn.dataset.atlOriginalHtml;
		}
	}

	function showFieldError(input, message) {
		if (!input) {
			return;
		}

		var errorEl = input.parentNode ? input.parentNode.querySelector('.atl-field-error') : null;
		if (!errorEl) {
			errorEl = d.createElement('div');
			errorEl.className = 'atl-field-error';
			input.parentNode.appendChild(errorEl);
		}

		errorEl.textContent = message;
		errorEl.style.display = 'block';
	}

	function clearFieldErrors(form) {
		var nodes = form.querySelectorAll('.atl-field-error');
		Array.prototype.forEach.call(nodes, function (node) {
			if (node.id === ERROR_ID) {
				return;
			}
			node.textContent = '';
			node.style.display = 'none';
		});
	}

	/**
	 * Validate Name / Email của comment form (khớp với FormFieldValidator phía PHP).
	 * @returns {boolean} true nếu hợp lệ.
	 */
	function validateFields(form) {
		clearFieldErrors(form);

		if (!w.ATLValidation) {
			return true;
		}

		var author = form.querySelector('[name="author"]');
		var email = form.querySelector('[name="email"]');
		var valid = true;
		var firstInvalid = null;

		if (author) {
			var nameError = w.ATLValidation.nameError(author.value, 'Name');
			if (nameError) {
				showFieldError(author, nameError);
				firstInvalid = firstInvalid || author;
				valid = false;
			}
		}

		if (email) {
			var emailError = w.ATLValidation.emailError(email.value);
			if (emailError) {
				showFieldError(email, emailError);
				firstInvalid = firstInvalid || email;
				valid = false;
			}
		}

		if (firstInvalid) {
			firstInvalid.focus();
		}

		return valid;
	}

	function handleSubmit(event) {
		var form = event.target;
		var submitBtn = getSubmitButton(form);
		var errorEl = d.getElementById(ERROR_ID);
		var hasRecaptcha = !!form.querySelector('.g-recaptcha');

		if (submitBtn && submitBtn.disabled) {
			event.preventDefault();
			return;
		}

		if (!validateFields(form)) {
			event.preventDefault();
			return;
		}

		if (hasRecaptcha) {
			if (!getRecaptchaResponse(form)) {
				event.preventDefault();
				if (errorEl) {
					errorEl.textContent = (config.errors && config.errors.recaptcha) || 'Please complete the reCAPTCHA verification.';
					errorEl.style.display = 'block';
				}
				return;
			}

			if (errorEl) {
				errorEl.textContent = '';
				errorEl.style.display = 'none';
			}
		}

		setButtonLoading(submitBtn, true);
	}

	function showRedirectFeedbackIfNeeded() {
		var params = new URLSearchParams(w.location.search);
		var successCode = params.get(SUCCESS_PARAM);

		if (successCode) {
			var successMessage = (config.success && config.success[successCode]) || '';
			if (successMessage) {
				showNoticeModal({
					title: config.modal_success_title || 'Review Submitted',
					message: successMessage,
					okText: config.modal_ok || 'OK',
					type: 'success'
				});
			}
			clearQueryParam(SUCCESS_PARAM);
			return;
		}

		var errorCode = params.get(ERROR_PARAM);
		if (!errorCode) {
			return;
		}

		var errorMessage = (config.errors && config.errors[errorCode]) || '';
		if (errorMessage) {
			showNoticeModal({
				title: config.modal_error_title || 'Comment Submission Failure',
				message: errorMessage,
				okText: config.modal_ok || 'OK',
				type: 'error'
			});
		}

		clearQueryParam(ERROR_PARAM);
	}

	function clearQueryParam(paramName) {
		try {
			var url = new URL(w.location.href);
			if (!url.searchParams.has(paramName)) {
				return;
			}
			url.searchParams.delete(paramName);
			var clean = url.pathname + url.search + url.hash;
			w.history.replaceState({}, '', clean);
		} catch (e) {
			// Ignore URL API errors on legacy browsers.
		}
	}

	function ensureNoticeModal() {
		var modal = d.getElementById(MODAL_ID);
		if (modal) {
			return modal;
		}

		modal = d.createElement('div');
		modal.id = MODAL_ID;
		modal.className = 'atl-form-notice-modal';
		modal.setAttribute('hidden', 'hidden');
		modal.setAttribute('role', 'dialog');
		modal.setAttribute('aria-modal', 'true');
		modal.setAttribute('aria-labelledby', 'atl-comment-notice-modal-title');

		modal.innerHTML =
			'<div class="atl-form-notice-modal__backdrop" data-atl-comment-notice-close></div>' +
			'<div class="atl-form-notice-modal__dialog">' +
				'<button type="button" class="atl-form-notice-modal__close" data-atl-comment-notice-close aria-label="Close">&times;</button>' +
				'<div class="atl-form-notice-modal__icon" aria-hidden="true"></div>' +
				'<h3 id="atl-comment-notice-modal-title" class="atl-form-notice-modal__title"></h3>' +
				'<p class="atl-form-notice-modal__message"></p>' +
				'<button type="button" class="site-button atl-form-notice-modal__btn" data-atl-comment-notice-close>OK</button>' +
			'</div>';

		d.body.appendChild(modal);

		modal.querySelectorAll('[data-atl-comment-notice-close]').forEach(function (node) {
			node.addEventListener('click', hideNoticeModal);
		});

		d.addEventListener('keydown', function (ev) {
			if (ev.key === 'Escape' && modal.classList.contains('is-open')) {
				hideNoticeModal();
			}
		});

		return modal;
	}

	function showNoticeModal(options) {
		options = options || {};
		var modal = ensureNoticeModal();
		var type = options.type === 'success' ? 'success' : (options.type === 'info' ? 'info' : 'error');
		var titleEl = modal.querySelector('.atl-form-notice-modal__title');
		var messageEl = modal.querySelector('.atl-form-notice-modal__message');
		var iconEl = modal.querySelector('.atl-form-notice-modal__icon');
		var btn = modal.querySelector('.atl-form-notice-modal__btn');

		modal.classList.remove(
			'atl-form-notice-modal--error',
			'atl-form-notice-modal--info',
			'atl-form-notice-modal--success'
		);
		modal.classList.add('atl-form-notice-modal--' + type);

		if (iconEl) {
			iconEl.innerHTML = type === 'success' ? ICON_SUCCESS : ICON_ERROR;
		}
		if (titleEl) {
			titleEl.textContent = options.title || (type === 'success' ? 'Review Submitted' : 'Submission not completed');
		}
		if (messageEl) {
			messageEl.textContent = options.message || '';
		}
		if (btn) {
			btn.textContent = options.okText || 'OK';
		}

		modal.removeAttribute('hidden');
		modal.classList.add('is-open');
		d.body.classList.add(BODY_OPEN_CLASS);

		if (btn) {
			btn.focus();
		}
	}

	function hideNoticeModal() {
		var modal = d.getElementById(MODAL_ID);
		if (!modal) {
			return;
		}
		modal.classList.remove('is-open');
		modal.setAttribute('hidden', 'hidden');
		d.body.classList.remove(BODY_OPEN_CLASS);
	}

	if (d.readyState === 'loading') {
		d.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})(window, document);
